module.exports = __webpack_public_path__ + "img/project-10.279c808d.png";